package com.bulut.mecitogullari.core.util

import kotlin.math.abs
import kotlin.math.roundToLong

/** Formats an amount as e.g. "2.044.598 ₺" — whole liras, no kuruş. */
fun formatAmount(amount: Double): String {
    val rounded = amount.roundToLong()
    val sign = if (rounded < 0) "-" else ""
    val grouped = abs(rounded).toString()
        .reversed()
        .chunked(3)
        .joinToString(".")
        .reversed()
    return "$sign$grouped ₺"
}

/** "49,2" → 49.2 ; "2.250,50" → 2250.5 ; "43" → 43.0 */
fun parseDecimalAmount(text: String): Double? {
    if (text.isBlank()) return null
    val normalized = if (text.contains(',')) {
        text.replace(".", "").replace(',', '.')
    } else {
        text
    }
    return normalized.trim().toDoubleOrNull()
}

/** Kuruş-precise: "9.675,00 ₺" — used in supplier/debt statements. */
fun formatAmountPrecise(amount: Double): String {
    val totalKurus = (amount * 100).roundToLong()
    val sign = if (totalKurus < 0) "-" else ""
    val lira = abs(totalKurus) / 100
    val kurus = abs(totalKurus) % 100
    val grouped = lira.toString()
        .reversed()
        .chunked(3)
        .joinToString(".")
        .reversed()
    return "$sign$grouped,${kurus.toString().padStart(2, '0')} ₺"
}
